import axios from 'axios';
import {TOKEN} from "../context/SignInContext"

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_KB_URL}`
});

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(TOKEN)
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem(TOKEN)
            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)

export const setKbRagBaseURL = (url) => {
    instance.defaults.baseURL = url;
};


export default instance;
